import React, { useState, useEffect } from "react";
import CustomTooltip from "../../../../Elements/Tooltip";

const WarningIcon = () => (
  <svg
    className="hs-section-warning"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
    <line x1="12" y1="9" x2="12" y2="13" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);

const SectionCard = ({ title, variant, children, defaultOpen = false, errors, summary }) => {
  const [open, setOpen] = useState(defaultOpen);

  const activeErrors = [].concat(errors || []).filter(Boolean);
  const hasErrors = activeErrors.length > 0;

  useEffect(() => {
    if (hasErrors) setOpen(true);
  }, [hasErrors]);

  const visibleChildren = React.Children.toArray(children);
  if (visibleChildren.length === 0) return null;

  return (
    <div className={`hs-section${open ? ' open' : ''}${variant ? ` hs-section--${variant}` : ''}`}>
      <div className="hs-section-header" onClick={() => setOpen(o => !o)}>
        <span className="hs-section-title">{title}</span>
        {!open && summary && <span className="hs-section-summary">{summary}</span>}
        {hasErrors && (
          <CustomTooltip title={activeErrors.join(' · ')} placement="right">
            <span className="hs-section-warning-wrap">
              <WarningIcon />
            </span>
          </CustomTooltip>
        )}
        <span className={`hs-section-chevron${open ? ' open' : ''}`}>&#8250;</span>
      </div>
      {open && <div className="hs-section-body">{children}</div>}
    </div>
  );
};

export default SectionCard;
